import { connect } from 'react-redux';
import {
  editBid,
  addBidNote,
  requestProposals,
  sendProposal,
  sendBid,
  removeBid,
} from '../modules/tour';

import ProposalOverview from './ProposalOverview';

const mapDispatchToProps = {
  addBidNote,
  editBid,
  removeBid,
  requestProposals,
  sendBid,
  sendProposal,
};

const mapStateToProps = state => ({
  proposals: state.tours.selectedTour.proposals,
  needFetch: state.tours.selectedTour.fetches.proposals.needFetch,
  isFetching: state.tours.selectedTour.fetches.proposals.isFetching,
  user: state.auth.profile.user,
});
const ProposalOverviewContainer = connect(mapStateToProps, mapDispatchToProps)(ProposalOverview);
export default ProposalOverviewContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/ProposalOverviewContainer.js